module.exports = __webpack_public_path__ + "media/images/dt-church-f95d9a2bf9df6bf9c2563a97e734edb5.png";